import React, { FC, useState } from "react";
import Typography, { TypographyProps } from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/styles";
import StyledTooltip from "./StyledTooltip";

const useStyles = makeStyles({
  truncate: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "default",
    margin: "0 auto",
  },
  measureSpan: {
    whiteSpace: "nowrap",
  },
});

interface EllipsisProps {
  text: string;
  width: number;
  variant: TypographyProps["variant"];
  tooltip?: string;
}

const Ellipsis: FC<EllipsisProps> = ({ text, width, variant, children, tooltip }) => {
  const classes = useStyles();

  const [isOverflow, setIsOverflow] = useState(false);

  const handleOverflow = (el) => setIsOverflow(el.getBoundingClientRect().width >= width);

  return (
    <>
      {isOverflow ? (
        <StyledTooltip
          title={
            <div>
              {text} {tooltip && <p>{tooltip}</p>}
            </div>
          }
        >
          <Typography
            component={"span"}
            variant={variant}
            className={classes.truncate}
            style={{ width, display: "block" }}
          >
            {children}
          </Typography>
        </StyledTooltip>
      ) : (
        <Typography component={"span"} variant={variant} style={{ display: "block" }}>
          <StyledTooltip title={tooltip || ""}>
            <span
              className={classes.measureSpan}
              ref={(el) => {
                if (!el) return;
                handleOverflow(el);
              }}
            >
              {children}
            </span>
          </StyledTooltip>
        </Typography>
      )}
    </>
  );
};

export default Ellipsis;
